var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.118pt",
    height: "10.038pt",
    viewBox: "0 0 11.118 10.038",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.125-2.375h-0.8125v2.375h0.35938v-0.95312h0.45312c0.54688 0 0.84375-0.26562 0.84375-0.71875 0-0.4375-0.29688-0.70312-0.84375-0.70312zm-0.45312 1.1406v-0.85938h0.4375c0.3125 0 0.48438 0.125 0.48438 0.42188 0 0.3125-0.17188 0.4375-0.48438 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-2.375v2.375h0.34375v-2.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7969-0.28125h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8906 0v-0.28125h-1.2656l1.2812-2.0469v-0.046875h-1.7031v0.28125h1.1875l-1.2812 2.0469v0.046875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.375h-0.3125l-0.70312 1.8125-0.21875 0.54688v0.015625h0.35938l0.015625-0.015625 0.1875-0.53125h1.0312l0.20312 0.53125v0.015625h0.375v-0.015625l-0.23438-0.57812zm0.26562 1.5625h-0.82812l0.40625-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.20312-0.10938c0.10938 0.0625 0.32812 0.14062 0.625 0.14062 0.53125 0 0.84375-0.28125 0.84375-0.67188 0-0.3125-0.15625-0.53125-0.54688-0.6875l-0.26562-0.09375c-0.20312-0.078125-0.28125-0.17188-0.28125-0.34375 0-0.1875 0.14062-0.34375 0.45312-0.34375 0.25 0 0.4375 0.09375 0.53125 0.15625h0.015625v-0.34375c-0.09375-0.046875-0.28125-0.10938-0.5625-0.10938-0.48438 0-0.79688 0.28125-0.79688 0.65625 0 0.28125 0.15625 0.51562 0.5 0.64062l0.26562 0.10938c0.23438 0.078125 0.32812 0.20312 0.32812 0.375 0 0.1875-0.125 0.35938-0.46875 0.35938-0.28125 0-0.51562-0.10938-0.64062-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.0781c0.29688 0 0.48438 0.10938 0.57812 0.1875v-0.35938c-0.09375-0.078125-0.29688-0.14062-0.59375-0.14062-0.59375 0-1.0938 0.4375-1.0938 1.2031s0.5 1.2031 1.0938 1.2031c0.29688 0 0.5-0.0625 0.59375-0.14062v-0.35938c-0.09375 0.078125-0.28125 0.20312-0.57812 0.20312-0.40625 0-0.75-0.29688-0.75-0.90625s0.34375-0.89062 0.75-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.95312-3h-0.34375v0.015625l0.34375 0.4375h0.26562zm0.84375 2.7188h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-477.64 -556.82)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 477.328,
    y: 559.22925,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 479.43286,
    y: 559.22925,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480.47021,
    y: 559.22925,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.54523,
    y: 559.22925,
    xlinkHref: "#glyph-18-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 484.71826,
    y: 559.22925,
    xlinkHref: "#glyph-18-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.08621,
    y: 559.22925,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 477.328,
    y: 563.0293,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 479.43286,
    y: 563.0293,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480.47021,
    y: 563.0293,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.47491,
    y: 563.0293,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 484.58237,
    y: 563.0293,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.61752,
    y: 563.0293,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 477.328,
    y: 566.82928,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 479.43286,
    y: 566.82928,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480.47021,
    y: 566.82928,
    xlinkHref: "#glyph-18-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.47491,
    y: 566.82928,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 484.58237,
    y: 566.82928,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.61752,
    y: 566.82928,
    xlinkHref: "#glyph-18-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieces);
export default __webpack_public_path__ + "static/media/pieces.08e3c7416c5fe43e9593d0222b831bb9.svg";
export { ForwardRef as ReactComponent };